import { CUSTOM_ROSTER_SELECTION_TYPE, FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { rosterAPI } from '@/providers/apis/roster/roster';
import moment from 'moment';
import { isAPICatchError } from '@/utils/utils';

@Component({
    name: 'course-details',
    components: {},
})

export default class RosterCourseDetails extends Vue {

    // -------------------------------------------------------------------
    // Properties
    @Prop()
    private rosterData: any;

    private courseList: any = [];

    private isLoading: boolean = false;

    private offset: number = 0;

    private limit: number = 10;

    private totalLength: number = 0;

    private currentPage: number = 1;

    private pageLimit: number = 10;


    public created() {

        this.isLoading = true;
        this.fetchCourselist();
    }


    // --------------------------------------------------------------------
    // Events


    // ---------------------------------------------------------------------
    // Actions
    private onClose() {
        this.$emit('onClose');
    }

    private onSelectPage(item: number) {
            this.isLoading = true;
            this.currentPage = item;
            this.offset = (item - 1) * this.pageLimit;
            this.fetchCourselist();
    }

    // ---------------------------------------------------------------------
    // Methods
    private fetchCourselist() {
        const params = {
            zipId: this.rosterData.id,
            offset: this.offset,
            limit: this.limit,
            is_required_sync: this.rosterData.showError,
        };

        rosterAPI.getCoursesDetails(params).then((courseList) => {
            this.isLoading = false;
            if (!isAPICatchError(courseList)) {
                this.courseList = courseList.courses;
                this.totalLength = courseList.totalCoursesCount;
            }
        });
    }
}
